/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IBillingQueryVariables = Types.Exact<{ [key: string]: never }>;

export type IBillingQuery = {
  __typename?: 'Query';
  billing?: {
    __typename?: 'Billing';
    subscriptions?: Array<{
      __typename?: 'BillingSubscription';
      billingPeriod: number;
      billingPeriodUnit: string;
      currencyCode: string;
      coupons?: Array<string> | null;
      status: string;
      total: number;
      plans: Array<{
        __typename?: 'Plan';
        id: string;
        name: string;
        currencyCode: string;
        period: number;
        periodUnit: string;
        price: number;
        externalName?: string | null;
      }>;
      addons: Array<{
        __typename?: 'Addon';
        name: string;
        price: number;
        currencyCode: string;
        quantity: number;
        unitPrice: number;
        periodUnit: string;
        externalName?: string | null;
      }>;
    }> | null;
    paymentMethod?: {
      __typename?: 'PaymentMethod';
      cardLast4?: string | null;
      cardType?: string | null;
      status: string;
      type: string;
    } | null;
    billingAddress?: {
      __typename?: 'BillingAddress';
      addressLine1?: string | null;
      city?: string | null;
      companyName?: string | null;
      companyRegistrationNumber?: string | null;
      country?: string | null;
      email?: string | null;
      firstName?: string | null;
      lastName?: string | null;
      state?: string | null;
      zip?: string | null;
    } | null;
    policy: {
      __typename?: 'BillingPolicy';
      applyCoupon: boolean;
      cancelSubscription: boolean;
      update: boolean;
      requestCancellation: boolean;
      requestExclusiveOffer: boolean;
    };
  } | null;
};

export const BillingDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'billing' },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'billing' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'subscriptions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'plans' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'period' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'periodUnit' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'externalName' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'billingPeriod' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'billingPeriodUnit' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'coupons' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'addons' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'price' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'currencyCode' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'quantity' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'unitPrice' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'periodUnit' } },
                            { kind: 'Field', name: { kind: 'Name', value: 'externalName' } },
                          ],
                        },
                      },
                      { kind: 'Field', name: { kind: 'Name', value: 'total' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'paymentMethod' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cardLast4' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cardType' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'billingAddress' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'BillingAddressFragment' } }],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'policy' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'applyCoupon' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cancelSubscription' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'update' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requestCancellation' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'requestExclusiveOffer' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'BillingAddressFragment' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'BillingAddress' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'addressLine1' } },
          { kind: 'Field', name: { kind: 'Name', value: 'city' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'companyRegistrationNumber' } },
          { kind: 'Field', name: { kind: 'Name', value: 'country' } },
          { kind: 'Field', name: { kind: 'Name', value: 'email' } },
          { kind: 'Field', name: { kind: 'Name', value: 'firstName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'lastName' } },
          { kind: 'Field', name: { kind: 'Name', value: 'state' } },
          { kind: 'Field', name: { kind: 'Name', value: 'zip' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IBillingQuery, IBillingQueryVariables>;
